exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticket-type-add-to-basket.sold-out[data-v-79bda97a]{opacity:.65}.ticket-type-add-to-basket.sold-out.enquiry-enabled[data-v-79bda97a]{opacity:1}.ticket-type-add-to-basket.sold-out .book-tickets-button[data-v-79bda97a]{cursor:not-allowed}.ticket-type-add-to-basket .quantity-down[data-v-79bda97a],.ticket-type-add-to-basket .quantity-up[data-v-79bda97a]{-webkit-user-select:none;user-select:none;cursor:pointer;opacity:.1;font-size:1.25rem}.ticket-type-add-to-basket .quantity-down.enabled[data-v-79bda97a],.ticket-type-add-to-basket .quantity-up.enabled[data-v-79bda97a]{opacity:.5}.ticket-type-add-to-basket .quantity-down.enabled[data-v-79bda97a]:hover,.ticket-type-add-to-basket .quantity-up.enabled[data-v-79bda97a]:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79bda97a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ticket-type-add-to-basket.vue
// module id = 8YFa
// module chunks = 116